const ITEMS = [
  "Dark Store Management",
  "Manpower-Led Operations",
  "QC Marketplace Management",
  "Warehousing & Fulfilment",
  "Supply Chain Enablement",
  "Last-Mile Coordination",
  "Daily MIS & SLA Control",
  "Multi-City Replication",
];

export default function BrandMarquee() {
  return (
    <div data-testid="brand-marquee" className="bg-white border-y border-neutral-200 py-5 overflow-hidden">
      <div className="flex gap-12 whitespace-nowrap oh-ticker-track">
        {[...ITEMS, ...ITEMS].map((t, i) => (
          <span key={i} className="flex items-center gap-3 text-neutral-500 font-bold text-xs uppercase tracking-[0.22em]">
            <span className="w-1.5 h-1.5 bg-[#99CC00] rounded-full" />
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
